import classNames from "classnames/bind";
import React, { useEffect } from "react";
import TextInputBare from "../../TextInput/TextInput";
import styles from "../DropdownInput.module.scss";
import { useDropdownContext } from "../DropdownContext";

const cx = classNames.bind(styles);

export const DropdownSearchInput = () => {
  const {
    id,
    pagination,
    setPagination,
    searchTerm,
    onSearchTermChange,
    searchInputRef,
  } = useDropdownContext();

  const onChange = (newSearchValue: string) => {
    onSearchTermChange?.(newSearchValue);
    setPagination?.({ searchTerm: newSearchValue });
  };

  useEffect(() => {
    // the popover is not immediately rendered, so focus is set after a small delay
    const timeout = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 50);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <TextInputBare
      className={cx("input")}
      value={pagination?.searchTerm ?? searchTerm ?? ""}
      placeholder="Search..."
      onChange={onChange}
      name={id ? `dropdown-search-input-${id}` : "dropdown-search-input"}
      type="search"
      ref={searchInputRef}
      autoFocus
    />
  );
};
